<m-input-style class="m-maskedfield"
               :disabled="isDisabled"
               :waiting="isWaiting"
               :error="hasMaskedfieldError"
               :valid="isMaskedfieldValid"
               :label="label"
               :label-for="id"
               :focus="isFocus"
               :label-up="labelUp"
               :empty="isEmpty"
               :readonly="isReadonly"
               :required-marker="requiredMarker"
               :required="required || requiredMarker"
               :tag-style="tagStyle"
               :error-message="errorMessage"
               :valid-message="validMessage"
               :helper-message="helperMessage"
               :style="{ width: inputWidth, maxWidth: inputMaxWidth }"
               @click="onClick">
    <slot name="prefix"
          slot="prefix" />
    <m-input-mask ref="inputMask"
                  v-model="model"
                  :id="id"
                  :autocomplete="autocomplete"
                  :disabled="isDisabled"
                  :readonly="isReadonly || isWaiting"
                  :placeholder="placeholder"
                  :raw="raw"
                  :options="maskOptions"
                  :aria-invalid="hasMaskedfieldError"
                  :aria-label="inputAriaLabel"
                  :aria-describedby="validationMessageId"
                  @blur="onBlur"
                  @change="onChange"
                  @focus="onFocus"
                  @keyup="onKeyup"
                  @keydown="onKeydown"
                  @paste="onPaste" />
    <slot name="suffix"
          slot="suffix" />
    <div slot="validation"
         :id="validationMessageId"
         class="m-maskedfield__validation">
        <m-validation-message class="m-maskedfield__validation-message"
                              :disabled="isDisabled"
                              :waiting="isWaiting"
                              :error="hasMaskedfieldError"
                              :error-message="errorMessage"
                              :valid="isMaskedfieldValid"
                              :valid-message="validMessage"
                              :helper-message="helperMessage" />
    </div>
</m-input-style>
